/**
 * Format a physician's address for display
 * @param {Object} physician - The physician object
 * @returns {string} - Formatted address or "-" if not available
 */
export const formatAddress = (physician) => {
  const parts = [];
  if (physician.address) parts.push(`${physician.address}${physician.suiteNumber ? `, ${physician.suiteNumber}` : ""}`);
  if (physician.city || physician.state || physician.zipCode) {
    const cityState = [physician.city, physician.state].filter(Boolean).join(", ");
    const zipCode = physician.zipCode || "";
    parts.push(`${cityState} ${zipCode}`.trim());
  }
  return parts.join(", ");
};

export const getUserName = (users, userId, defaultUser) => {
  if (!userId) return defaultUser;
  const user = users[userId];
  if (user && user.firstName && user.lastName) {
    return `${user.lastName}, ${user.firstName}`;
  } else if (user && user.name && (!user.firstName || !user.lastName)) {
    return user.name;
  }
  return defaultUser;
};
